import { render } from "./ResultStatSkipped.vue?vue&type=template&id=56f81476&scoped=true"
import script from "./ResultStatSkipped.vue?vue&type=script&lang=js"
export * from "./ResultStatSkipped.vue?vue&type=script&lang=js"

import "@/css/components/c-result-stat-skipped.css?vue&type=style&index=0&id=56f81476&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56f81476"]])

export default __exports__